var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('horiz-field',{attrs:{"horizontal":false}},[_vm._t("label",null,{"slot":"label"}),_vm._t("default"),_vm._t("icon",null,{"slot":"icon"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }